import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "year-group-manager",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "year-group-manager" */ "AdminSettings/routes/YearGroupManagerWrapper/routes/YearGroupManager/components"
      ),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [],
});
